/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-enable import/no-unresolved, import/default */
// import jsonConfigurationTemplate from '../json-configuration/json-configuration.tpl.html';

/*@ngInject*/
export default function ConverterStatisticsConfig(statisticsService) {

    var service = {
        getConfig: getConfig
    };

    return service;

    function getConfig() {

        var tableConfiguration = {

            title: 'converter-statistics.statistics',
            method: statisticsService.getConverterStatistics,

            subEntities: [
                {
                    key: 'encoder',
                    title: 'converter.encoder'
                },
                {
                    key: 'decoder',
                    title: 'converter.decoder'
                }
            ],

            metrics: [
                {
                    key: 'invoked',
                    title: 'converter-statistics.invoked'
                },
                {
                    key: 'skippedBanned',
                    title: 'converter-statistics.skipped-banned'
                },
                {
                    key: 'failed',
                    title: 'converter-statistics.failed',
                },
                {
                    key: 'failedTimeout',
                    title: 'converter-statistics.failed-timeout'
                }
            ]
            
        };

        return tableConfiguration;
    }
}


// WEBPACK FOOTER //
// ./src/app/converter/converter-statistics.config.js